import { CommerceToolsApi } from "@grandvisionhq/commercetools";
import { Types } from "@grandvisionhq/graphql";
const upperFirst = (value) => {
  return value[0] ? value[0].toUpperCase() + value.slice(1) : value;
};
const mapToProductType = (lineItemRaw) => {
  switch (lineItemRaw.bundleLineItemsType) {
    case Types.BundleLineItemType.NON_PRESCRIPTION_BUNDLE:
    case Types.BundleLineItemType.PRESCRIPTION_GLASSES:
      const mainLineItem = lineItemRaw.bundleLineItems.find((l) => l.isMainBundleLineItem);
      const productType = mainLineItem?.legacyProduct.productType;
      if (!productType) {
        return null;
      }
      const capitalized = upperFirst(productType);
      if (!CommerceToolsApi.isProductTypeName(capitalized)) {
        return null;
      }
      return capitalized;
    default:
      console.warn(`Unrecognized bundle line item type ${lineItemRaw.bundleLineItemsType}`);
      return null;
  }
  return null;
};
const getProductUrl = (productLinkFormatter, lineItemRaw, slug, locale) => {
  if (!slug || !productLinkFormatter) {
    return void 0;
  }
  if (lineItemRaw.__typename === "LineItemBundle") {
    const productType = mapToProductType(lineItemRaw);
    if (!productType) {
      return void 0;
    }
    return productLinkFormatter({ [locale]: slug }, lineItemRaw.sku, productType);
  }
  return productLinkFormatter(
    { [locale]: slug },
    lineItemRaw.sku,
    upperFirst(lineItemRaw.legacyProduct.productType)
  );
};
export {
  getProductUrl
};
//# sourceMappingURL=get-line-item-product-url.js.map
